<template>
	<div class="p_box">
		<el-breadcrumb separator="/">
			<el-breadcrumb-item :to="{ path: '/Homet' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>布置作业</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="p_flex p_m_t_180 p_f_r">
			<div class="select_box small_hand" v-for="(item, index) in selectList" :key="index"
				 @click="goSingle(item.id)">
				<div class="select_img"><img :src="item.img"/></div>
				<span class="type_size_22 p_flex p_f_c">{{ item.name }}</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Layout',
	data() {
		return {
			selectList: [{
				id: 2,
				name: '从我的题库选择',
				img: require('../../../assets/img/组 440.png')
			},
				{
					id: 1,
					name: '从校本题库选择',
					img: require('../../../assets/img/a.png')
				}
			]
		};
	},
	methods: {
		goSingle(i) {
			this.$router.push({
				path: '/Mine',
				query: {
					id: i
				}
			})
		}
	}
};
</script>

<style lang="scss" scoped>
.select_box {
	width: 270px;
	height: 400px;
	background: #ffffff;
	border-radius: 10px;
}

.select_img {
	width: 204px;
	height: 196px;
	margin: 50px auto;
}

img {
	width: 100%;
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/layout/index.vue